import {
  BOOTSTRAP,
  BootstrapActionPayload,
  LOAD_MORE_ARTICLES_FULFILLED,
  LOAD_MORE_HOLIDAYS,
  LOAD_MORE_HOLIDAYS_FULFILLED,
  LoadMoreArticlesActionPayload,
  LoadMoreHolidaysActionPayload,
  LoadMoreGroupHolidaysActionPayload,
  LOAD_MORE_GROUP_HOLIDAYS_FULFILLED,
} from './actions';
import { TravelCollection } from '../../../models/travelCollection';
import { Brand } from '../../../lib/theme';
import createReducer from '../../../lib/createReducer';

export interface TravelCollectionState extends TravelCollection {
  brand: Brand;
  adConfig: {
    units: {
      [key: string]: string;
    };
  };
  isLoading: boolean;
}

const initialState = {
  brand: 'sas',
  adConfig: {
    units: {},
  },
  isLoading: false,
};

const handleBootstrap = (
  state: TravelCollectionState,
  travelCollection: BootstrapActionPayload
): TravelCollectionState => ({
  ...state,
  ...travelCollection,
});

const handleLoadMoreArticles = (
  state: TravelCollectionState,
  { stories, moreArticlesURL }: LoadMoreArticlesActionPayload
): TravelCollectionState =>
  state.storiesBlock
    ? {
        ...state,
        storiesBlock: {
          ...state.storiesBlock,
          linkUrl: moreArticlesURL,
          stories: [...state.storiesBlock.stories, ...stories],
        },
      }
    : { ...state };

const handleLoadMoreHolidays = (
  state: TravelCollectionState,
  { holidays, moreHolidaysURL }: LoadMoreHolidaysActionPayload
): TravelCollectionState =>
  state.holidaysBlock
    ? {
        ...state,
        isLoading: false,
        holidaysBlock: {
          ...state.holidaysBlock,
          moreHolidaysURL,
          holidays: [...state.holidaysBlock.holidays, ...holidays],
        },
      }
    : { ...state };

const handleLoadMoreGroupHolidays = (
  state: TravelCollectionState,
  { holidays, cursor, holidayGroupIndex }: LoadMoreGroupHolidaysActionPayload
): TravelCollectionState => ({
  ...state,
  holidayGroups:
    state.holidayGroups &&
    state.holidayGroups.map((group, i) =>
      i === holidayGroupIndex
        ? {
            ...group,
            holidays: [...group.holidays, ...holidays],
            backfillCursor: cursor,
          }
        : group
    ),
});

const handleLoadMoreHolidaysPending = (
  state: TravelCollectionState,
  _: any
): TravelCollectionState => ({
  ...state,
  isLoading: true,
});

const handlers = {
  [BOOTSTRAP]: handleBootstrap,
  [LOAD_MORE_ARTICLES_FULFILLED]: handleLoadMoreArticles,
  [LOAD_MORE_HOLIDAYS]: handleLoadMoreHolidaysPending,
  [LOAD_MORE_HOLIDAYS_FULFILLED]: handleLoadMoreHolidays,
  [LOAD_MORE_GROUP_HOLIDAYS_FULFILLED]: handleLoadMoreGroupHolidays,
};

export default createReducer(handlers, initialState);
